document.addEventListener('DOMContentLoaded', function() {
  // Select the button
  const submitButton = document.querySelector('.in-the-spotlight .product-form__submit');
  
  // Add click event listener to the button
  if (submitButton) {
      submitButton.addEventListener('click', function() {
          // Select the custom element with the class 'cart-drawer'
          const cartDrawer = document.querySelector('cart-drawer.drawer');
          
          // Check if the element exists
          if (cartDrawer) {
              // Set the style attribute to display: none;
              cartDrawer.style.display = 'none';
          }
      });
  }
});